'use client'
import { mobileNavigationStyles } from './mobile-navigation.style'
import { useEffect, useMemo, useState } from 'react'
import { Switch } from '@/jupiter/components/switch/switch'
import { BreakpointDisplayWrapper } from '@/features/breakpoint/components'
import { Breakpoint } from '@/features/breakpoint'
import { useAccountInfo } from '@/hooks/query/account'
import { cookieService } from '@/services/cookie.service'
import { Maybe } from '@nf/utils-common/fpw/monadic'
import { fetchComposer } from '@nf/utils-common/compose-fetch'
import { cloudUrlParser } from '@/utils/aws-domain-util'
import { useSiteStore } from '@/store/site'
import { useAuthToken } from '@/store/auth'
import { ConfirmModal } from '../component/check-modal'
import { useTranslations } from 'next-intl'
import { GestureSettingModal } from '../gesture-setting-modal'

export const MobileNavigation = () => {
	const t = useTranslations('General');
	const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
	const [isGestureSettingModalOpen, setIsGestureSettingModalOpen] = useState(false);
	const { 
		isGestureEnable, 
		disableGesture,
		updateGestureUsersList
	} = useGestureSwitch();
	const handleSwitch = () => {
		if (isGestureEnable) {
			setIsConfirmModalOpen(true);
		} else {
			setIsGestureSettingModalOpen(true);
		}
	};
	const handleConfirm = () => {
		setIsConfirmModalOpen(false);
		disableGesture();
	}

	const handleGestureSettingModalClose =() => {
		updateGestureUsersList();
		setIsGestureSettingModalOpen(false);
	}

	return (
		<div className={mobileNavigationStyles.container}>			
			<BreakpointDisplayWrapper maxBreakpoint={Breakpoint.sm}>
				<div 
					className={mobileNavigationStyles.item}
					onClick={handleSwitch}
				>
					{t('lbl_GestureLogin')}
					<Switch 
						active={isGestureEnable}
						
					/>
				</div>
				
				<div className={mobileNavigationStyles.bottomText}>
					<span>{t('lbl_GestureNote01')}</span>
					<span>{t('lbl_GestureNote02')}</span>
				</div>
			</BreakpointDisplayWrapper>
			<ConfirmModal 
				title={t('lbl_LockMsg_ConfirmCancel')} 
				text={t('lbl_GestureOff')} 
				isOpen={isConfirmModalOpen} 
				setIsOpen={setIsConfirmModalOpen}
				handleConfirm={handleConfirm}	
			/>
			<GestureSettingModal
				isOpen={isGestureSettingModalOpen}
				closeModal={handleGestureSettingModalClose}
			/>	
		</div>
	)
}

function useGestureSwitch() {
	const { user } = useAccountInfo();
	const [gestureUsersList, setGestreUsersList] = useState(() => cookieService.getGestureUsers());
	
	const isGestureEnable = useMemo(
		() => !!(user?.LoginUserName && gestureUsersList.includes(user?.LoginUserName)), 
		[user?.LoginUserName, gestureUsersList]
	);
	const authToken = useAuthToken();
	const apiDomain = useSiteStore((state) => state.apiDomain);

	function updateGestureUsersList () {
		setGestreUsersList(cookieService.getGestureUsers());
	}

	function disableGesture () {
		Maybe(user?.LoginUserName).chain(cookieService.removeGestureUserName);
		RemoveGesture();
		updateGestureUsersList();
	}

	async function RemoveGesture () {
		try {
			const response = await fetchComposer.postWithBearer(
				cloudUrlParser(`${apiDomain.ctcdDomain}/setting/RemoveGesture`),
				{
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
						Accept: 'application/json',
					},
				}
			)(authToken);
			const data = await response.json();
			if (data?.Data.Code ==1) {
				return true;
			} else {
				throw new Error('Remove Gesture Error');
			}
		} catch (e) {
			throw e;
		}
	}
	
	return {
		isGestureEnable,
		updateGestureUsersList,
		disableGesture
	}
}